//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductIcon from '@motionelements/core/src/components/product/ProductIconShiny.vue';

export default {
  name: 'product-card-loader',
  props: {
    productType: {
      type: String,
    },
  },
  components: {
    ProductIcon,
  },
};
